import React from "react";
import './HappyCustomers.css';
import reviews from "./reviews";

const HappyCustomers = () => {
    return (
        <section className="happy-customers-section" id='happycustomer'>
            <div className="happy-customer-title">
                <h2 className="happy-customer-heading"><span className="our-happy-text">OUR HAPPY</span><span className="customers-green-text"> CUSTOMERS</span></h2>
                <p className="happy-customer-subtitle">We don’t just deliver products—we build relationships based on trust, integrity, and commitment.</p>
            </div>
            <div className="scroll-row scroll-left">
                {[...reviews, ...reviews].map((item, index) => (
                    <div className="review-card" key={`top-${index}`}>
                        <div className="rating-stars"> ★★★★★</div>
                        <h4 className="review-title">{item.name} <span class="green-tick">&#10003;</span></h4>
                        <p className="review-text">{item.text}</p>
                    </div>
                ))}
            </div>
            <div className="scroll-row scroll-right">
                {[...reviews, ...reviews].map((item, index) => (
                    <div className="review-card" key={`bottom-${index}`}>
                        <div className="rating-stars"> ★★★★★</div>
                        <h4 className="review-title">{item.name} <span className="green-tick">&#10003;</span></h4>
                        <p className="review-text">{item.text}</p>
                    </div>
                ))}
            </div>
        </section>
    )
}

export default HappyCustomers;